<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.setting.editUser')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <back-button></back-button>


                 <b-alert v-model="showDisableAlert"  variant="info"> {{disableEditFormMessage}}
                    <button v-if="!firstLoad && sessionCreated" @click="checkForEdit(true)">
                         <i class="fas fa-sync"></i>
                    </button>
                </b-alert>

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <form role="form" @submit.prevent="submit()">
                        <div class="card-header bg-light">
                            <div class="card-title">{{$t('form.setting.editUser')}}</div>
                            <button class="btn btn-primary float-right"
                                :disabled="disableEditForm || !permissions.editSettingsUsers">{{$t('button.update')}}</button>
                        </div>

                        <div class="card-body">

                            <div class="form-group">
                                <label>{{$t('form.setting.fullName')}}<span class="text-danger">*</span></label>
                                <input type="text" class="form-control" v-model="formuser.name">
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.email')}}<span class="text-danger">*</span></label>
                                <input type="email" class="form-control" v-model="formuser.email">
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.username')}}</label>
                                <input type="text" class="form-control" v-model="formuser.username" :class="{ 'is-invalid': $v.formuser.username.$error }">

                                <div class="invalid-feedback" v-if="!$v.formuser.username.required">
                                {{$t('form.validation.required')}}
                                </div>

                            </div>

                            <p class="text-muted">{{$t('form.setting.leavePasswordFieldText')}}</p>

                            <div class="form-group">
                                <label>{{$t('form.setting.password')}}<span class="text-danger"
                                        v-if="formuser.password">*</span></label>
                                <input type="password" class="form-control" v-model="formuser.password">
                            </div>

                            <div class="form-group" v-if="formuser.password">
                                <label>{{$t('form.setting.confirmPassword')}}<span class="text-danger">*</span></label>
                                <input type="password" class="form-control" v-model="formuser.password_confirmation">
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.partner')}}</label>
                                <v-select label="PartnerCode" :options="partners" v-model="formuser.partner_id"
                                    :reduce="partners => partners.PartnerID">
                                </v-select>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.staff')}}</label>
                                <v-select label="FullName" :options="staff" v-model="formuser.staff_id"
                                    :reduce="staff => staff.ID">
                                </v-select>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.status')}}</label>
                                <select class="form-control" v-model="formuser.status"  :disabled="isOwner">
                                    <option value="1" >{{$t('form.setting.enabled')}}</option>
                                    <option value="0">{{$t('form.setting.disabled')}}</option>
                                </select>
                                <p class="text-muted" v-show="isOwner">{{$t('form.setting.changeStatus')}}</p>
                            </div>

                            <div class="form-group">
                                  <button type="button" @click="tokenRevoke()" class="btn btn-primary btn-sm">{{$t('form.setting.tokenRevoke')}}</button>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.authentication')}}<span class="text-danger">*</span></label>
                                <select class="form-control" v-model="formuser.authenticate_by">
                                    <option value="ldap">{{$t('form.setting.ldap')}}</option>
                                    <option value="local">{{$t('form.setting.local')}}</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.role')}}<span class="text-danger">*</span></label>
                                <v-select @input="onChangeRoles" v-model="selectedRoles" label="name" :options="roles" multiple :class="{ 'is-invalid': rolesError }"></v-select>
                                <div class="invalid-feedback" v-if="rolesError">
                                {{$t('form.validation.required')}}
                                </div>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.google2FAMode')}}</label>
                                <select class="form-control" v-model="formuser.google2fa_mode">
                                    <option value="disabled">{{$t('form.setting.disabled')}}</option>
                                    <option value="optional">{{$t('form.setting.optional')}}</option>
                                    <option value="enforced">{{$t('form.setting.enforced')}}</option>
                                </select>
                            </div>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    </div>
</template>
<script>

 import {
        required,
        minLength,
        maxLength,
        decimal,
        alpha,
        numeric
    } from "vuelidate/lib/validators";

    export default {
        props: ['permissions', 'editFormInterval', 'user'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                interval: '',
                disableEditFormMessage: '',
                disableEditForm: false,
                closing: true,

                showDisableAlert: false,
                firstLoad:true,
                sessionCreated:true,
                continueInterVal:true,

                formuser: {
                    id: '',
                    name: '',
                    username: '',
                    email: '',
                    password: '',
                    password_confirmation:'',
                    authenticate_by: '',
                    partner_id: null,
                    staff_id: null,
                    google2fa_mode: '',
                    status: null,
                },

                selectedRoles: [],
                roles: [],
                rolesError: false,
                partners: [],
                staff: []
            }
        },
          validations: {
            formuser: {  
                 name: {
                    required,
                    maxLength: maxLength(255)
                }, 
                username:{
                        required,
                         maxLength: maxLength(255)
                },
                email:{
                        required,
                         maxLength: maxLength(255)
                    },
                password:{
                        maxLength: maxLength(255),
                        minLength: minLength(6)
                    },
                password_confirmation:{
                        maxLength: maxLength(255),
                        minLength: minLength(6)
                    },
                 
                },

        },


        mounted() {
            if (!this.permissions.viewSettingsUsers) {
                this.$router.push('/');
                return;
            }

            if (this.permissions.editSettingsUsers) {
                this.checkForEdit();
                let self = this;

                this.interval = setInterval(() => {
                    if(self.continueInterVal)
                    self.checkForEdit();
                    }, this.editFormInterval);
            }

            this.getInitialData();
            this.getUser();
        },

        computed: {
            isOwner() {
                return this.formuser.id === this.user.id;
            }
        },

        watch: {
            formuser: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            },
            selectedRoles: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            }
        },

        methods: {

            tokenRevoke(){
                this.isLoading = true;
                axios.get('/api/users/revoke-token/'+this.formuser.id).then(response=>{
                    this.showAlert(response.data);
                        this.isLoading = false;
                }).catch(error=>{
                        this.isLoading = false;
                })
            },
            showAlert(message, cls = 'success') {
                this.alertMessage = message;
                this.alertClass = cls;
                this.alert = true;
            },
             onChangeRoles(){
                if(this.selectedRoles.length == 0){
                    this.rolesError = true;
                }else{
                    this.rolesError = false;
                }
            },

            checkForEdit(refresh = false)
            {

                    if(refresh)
                    this.continueInterVal = true;
                    let data= {
                        'field_id':this.$route.params.id,
                        'form':this.$route.name,
                        'refresh':refresh,
                    }
                    // if(refresh) this.showDisableAlert = false;
                    axios
                    .post("/api/check-for-edit-session" , data)
                    .then(response => {

                        this.sessionCreated = true;
                        if (response.data.warning == 0) {

                            this.disableEditForm = false;
                            this.showDisableAlert = false;
                            if(this.firstLoad)
                            {
                                this.firstLoad = false;
                                this.getUser();
                            }
                        }

                        if (response.data.warning == -1) {
                            this.disableEditForm = false ;
                            this.showDisableAlert = false;
                        }

                        if (response.data.warning == 1) {
                             this.firstLoad = false;
                            this.disableEditFormMessage = response.data.message;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                            this.continueInterVal = false;
                        }

                        if (response.data.warning == 2) {
                            let msg = response.data.message;
                            if(this.firstLoad){
                              msg.replace('re-open' ,'open');
                            }
                            this.sessionCreated = false;
                            this.disableEditFormMessage = msg;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                        }
                        if (response.data.warning == 3) {
                            this.disableEditForm = false;
                            this.showDisableAlert = true;
                            this.disableEditFormMessage = response.data.message;
                        }
                    })
                    .catch(error => {
                        console.log('error');
                    })
                },

            submit() {
                if (this.disableEditForm) {
                    return;
                }

                 this.$v.$touch();
                // apply vue validation

                if (this.$v.$invalid) {
                let errorMsg = '';

                ;

                if(this.$v.formuser.name.$error){
                    errorMsg = errorMsg ? errorMsg +", "+this.$t('form.setting.fullName'): this.$t('form.setting.fullName');
                }

                 if(this.$v.formuser.username.$error){
                    errorMsg = errorMsg ? errorMsg +", "+this.$t('form.setting.username'): this.$t('form.setting.username');
                }

                if(this.$v.formuser.email.$error){
                    errorMsg = errorMsg ? errorMsg +", "+this.$t('form.setting.email'): this.$t('form.setting.email');
                }


                if(this.$v.formuser.password.$error){
                    errorMsg = errorMsg ? errorMsg +", "+this.$t('form.setting.password'): this.$t('form.setting.password');
                }

                if(this.$v.formuser.password_confirmation.$error){
                    errorMsg = errorMsg ? errorMsg +", "+this.$t('form.setting.confirmPassword'): this.$t('form.setting.confirmPassword');
                }

                if(this.formuser.password != this.formuser.password_confirmation){
                    errorMsg = errorMsg ? errorMsg +": "+this.$t('form.setting.passwordNotMatch'): this.$t('form.setting.passwordNotMatch');
                } 


                if(this.selectedRoles.length == 0){
                      errorMsg = errorMsg ? errorMsg +", "+this.$t('form.setting.role'):this.$t('form.setting.role');
                }

                 this.showAlert(this.$t('form.validation.mandatoryFieldsError', {errors:errorMsg}), 'danger');
                    return; 
                }

                


                if (this.formuser.password != '' && this.formuser.password != this.formuser.password_confirmation) {
                    this.showAlert(this.$t('form.validation.passwordNotMatch'), 'danger');
                    return;
                }

                this.isLoading = true;

                let roles = [];

                this.selectedRoles.forEach((role) => roles.push(role.id));

                axios
                    .put(`/api/users/${this.$route.params.id}`, {
                        roles: roles,
                        user: JSON.stringify(this.formuser)
                    })
                    .then(response => {
                        this.isLoading = false;
                        this.closing = true;

                        clearInterval(this.interval);
                        this.showAlert(response.data.message);

                        if (response.status == 200) {
                            this.showAlert(response.data);

                            setTimeout(() => {
                                this.$router.push({
                                    name: 'UserIndex'
                                });
                            }, 2000);
                        }
                    })
                    .catch(error => {
                         let errorMsg = '';

                        if(error.response.data.errors.email){
                           
                            errorMsg= error.response.data.errors.email[0];
                            
                        }else{
                            errorMsg = error.response.data.message;
                        };

                        this.showAlert(errorMsg, 'danger');

                        this.isLoading = false;
                    });
            },

            getUser() {
                this.isLoading = true;

                axios
                    .get('/api/users/' + this.$route.params.id + '/edit')
                    .then(response => {

                        this.selectedRoles = [];
                        this.formuser = response.data.user;
                        this.roles = response.data.roles;

                        response.data.roles.forEach((role) => {
                            response.data.user_role.forEach((userRole) => {
                                if (userRole.id == role.id)
                                    this.selectedRoles.push(role);
                            });
                        });

                        setTimeout(() => {
                            this.isLoading = false;
                            this.closing = true;
                        }, 2000);

                    }).catch(error => {
                        console.log(error.response);

                        this.isLoading = false;
                    });
            },

            getInitialData() {
                axios
                    .get('/api/users/initial-data')
                    .then((response) => {
                        this.partners = response.data.partners;
                        this.staff = response.data.staff;

                        this.staff.map(s => s.FullName = `${s.FirstName} ${s.LastName}`);
                    })
                    .catch(error => console.log(error.response));
            }
        },

        beforeRouteLeave(to, from, next) {
            clearInterval(this.interval);
            if (this.closing) next()
            else {
                const answer = window.confirm(this.$t('leavePrompt'))

                if (answer) {
                    next()
                } else {
                    next(false)
                }
            }
        }

    }

</script>
